import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Linkify from '../Linkify';

const Description = ({ description }) => {
    const textLengthCutoff = 150;
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const truncateDescription = (descriptionText, maxTextLength) => {
        return descriptionText?.slice(0, maxTextLength);
    };

    return (
        <Linkify>
            {description.length < textLengthCutoff ? (
                <Typography whiteSpace="pre-wrap" sx={{ wordWrap: 'break-word' }} mb={2}>
                    {description}
                </Typography>
            ) : (
                <Typography whiteSpace="pre-wrap" sx={{ wordWrap: 'break-word' }} mb={2}>
                    {isExpanded ? description : truncateDescription(description, textLengthCutoff)}
                    <Typography color="primary" component="span" onClick={toggleExpanded} sx={{ cursor: 'pointer' }}>
                        {isExpanded ? ' show less' : ' ...read more'}
                    </Typography>
                </Typography>
            )}
        </Linkify>
    );
};

export default Description;
